const IconResize = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 420 250">
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        x1="-45.772"
        y1="-224.722"
        x2="-45.772"
        y2="-81.697"
        id="gradient-0"
        spreadMethod="pad"
        gradientTransform="matrix(1.752272, -0.000019, 0, 0.024745, 16.412995, -237.920888)"
      >
        <stop offset={0} style={{ stopColor: "currentColor" }} />
        <stop offset={1} style={{ stopColor: "currentColor" }} />
      </linearGradient>
    </defs>
    <path
      d="M 307.244 127.182 H 307.244 L 307.244 11.206 L 421.142 128.01 L 307.244 244.814 L 307.244 128.838 H 307.244 V 127.182 Z"
      style={{ fill: "currentColor", stroke: "currentColor" }}
    />
    <path
      d="M -120.741 -125.916 H -120.741 L -120.741 -243.481 L -6.843 -125.088 L -120.741 -6.695 L -120.741 -124.26 H -120.741 V -125.916 Z"
      style={{
        stroke: "currentColor",
        fillRule: "nonzero",
        fill: "url(#gradient-0)",
        paintOrder: "stroke markers",
      }}
      transform="matrix(-1, 0, 0, -1, 0, 0)"
    />
    <rect
      x="114.147"
      y="67.584"
      width="199.265"
      height="114.022"
      style={{ fill: "currentColor", stroke: "currentColor" }}
    />
    <text
      style={{
        fill: "#fff",
        fontFamily: "Arial, sans-serif",
        fontSize: 44,
        whiteSpace: "pre",
        userSelect: "none",
      }}
      x="44.905"
      y="151.651"
      dx="-12.976"
      dy="17.611"
      transform="matrix(1.752272, 0, 0, 1.655558, -9.984143, -124.273872)"
    >
      拡大･縮小
    </text>
  </svg>
);

export default IconResize;
